var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 6.49992C0.666504 6.49992 3.4585 2.49992 7.99984 2.49992C8.63117 2.49992 9.22584 2.58059 9.78517 2.71459L5.57317 6.92659C5.41594 6.58349 5.3341 6.21066 5.33317 5.83325C5.33317 5.20859 5.5565 4.64192 5.9165 4.18725C4.32184 4.72859 3.10717 5.77725 2.41384 6.49992C3.00446 7.11612 3.67221 7.65346 4.4005 8.09859L3.43184 9.06725C1.6645 7.91992 0.666504 6.49992 0.666504 6.49992ZM15.3332 6.49992C15.3332 6.49992 12.5412 10.4999 7.99984 10.4999C7.36917 10.4999 6.77584 10.4173 6.21584 10.2846L3.33317 13.1666L2.33317 12.1666L13.6665 0.833252L14.6665 1.83325L12.5685 3.93125C14.3338 5.07925 15.3332 6.49992 15.3332 6.49992ZM13.5898 6.50392C12.9982 5.88601 12.3288 5.34751 11.5985 4.90192L10.6665 5.83325C10.6665 6.5405 10.3856 7.21877 9.88546 7.71887C9.38536 8.21897 8.70708 8.49992 7.99984 8.49992L7.3685 9.13125C7.57517 9.15192 7.7845 9.16659 7.99984 9.16659C10.6518 9.16659 12.6285 7.51459 13.5898 6.50392Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.bdc4b4d62726760cbac76bd90ebd8276.svg";
export { ForwardRef as ReactComponent };